module.exports = __webpack_public_path__ + "img/team.84b4f1ba.svg";